module.exports = __webpack_public_path__ + "img/SWP_Sword_2H_03.18de12c4.png";